/* global axios */
export const receiptAccept =
  '.pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp';
export const receiptTypes = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
];
export function validateReceipt(file) {
  if (!(file instanceof File) || !file.size || file.size > 10 * 1024 * 1024)
    throw new Error('Размер файла — от 1 байта до 10 МБ.');
  if (
    !receiptTypes.includes(file.type) &&
    !(file.type === '' && /\.(pdf|jpe?g|png|webp)$/i.test(file.name))
  )
    throw new Error('Подойдут PDF, JPG, PNG или WebP.');
}
export function receiptError(error) {
  const messages = {
    receipt_storage_full:
      'Недостаточно места для чека на сервере. Обратитесь к администратору.',
    receipt_dimensions:
      'Изображение слишком большое. Максимум — 24 мегапикселя. Уменьшите фото или загрузите скриншот.',
    receipt_limit: 'Можно прикрепить до 5 чеков к размещению.',
    receipt_size: 'Файл слишком большой. Максимум — 10 МБ.',
    receipt_type: 'Подойдут PDF, JPG, PNG или WebP.',
    invalid_receipt:
      'Не удалось прочитать файл. Выберите другой PDF или изображение.',
    receipt_busy: 'Другой чек ещё обрабатывается. Нажмите «Повторить».',
    receipt_processing_timeout:
      'Обработка заняла слишком долго. Попробуйте изображение меньшего размера.',
    request_key_conflict:
      'Данные загрузки изменились. Обновите список перед дальнейшими действиями.',
  };
  if ([401, 403].includes(error.response?.status))
    return 'Нет доступа к чекам.';
  return (
    messages[error.response?.data?.error] ||
    (error.response?.status === 413
      ? messages.receipt_size
      : 'Загрузка не завершена. Нажмите «Повторить»: дубль не появится.')
  );
}
export async function uploadReceipt(
  accountId,
  grantId,
  entry,
  signal,
  onProgress
) {
  const data = new FormData();
  data.append('file', entry.file);
  data.append('request_key', entry.key);
  return (
    await axios({
      url: `/api/v1/accounts/${accountId}/tg_placements/${grantId}/receipts`,
      method: 'post',
      data,
      timeout: 120000,
      signal,
      onUploadProgress: event =>
        onProgress(
          event.total
            ? Math.min(99, Math.round((event.loaded * 100) / event.total))
            : 0
        ),
    })
  ).data.receipt;
}
// Bound simultaneous binary fetches across visible thumbnails and viewers.
let active = 0;
const waiting = [];
function pump() {
  while (active < 2 && waiting.length) {
    active += 1;
    waiting.shift()();
  }
}
function release() {
  active -= 1;
  pump();
}
export async function receiptBlob(
  accountId,
  grantId,
  receiptId,
  variant,
  signal
) {
  await new Promise(resolve => {
    waiting.push(resolve);
    pump();
  });
  try {
    if (signal.aborted) throw new Error('cancelled');
    const result = await axios({
      url: `/api/v1/accounts/${accountId}/tg_placements/${grantId}/receipts/${receiptId}?variant=${variant}`,
      method: 'get',
      responseType: 'blob',
      timeout: 30000,
      signal,
    });
    if (signal.aborted) throw new Error('cancelled');
    return result.data;
  } finally {
    release();
  }
}
